import React from 'react';
import { Currency, Header5Text } from 'ui-toolkit';
import { CardTW } from '../../../../tailwindComponents/CardTW/CardTW';
import { ActualBalanceMoneyLabel } from '../../escrow/escrowHeader/ActualBalanceLabel';
import { AvailableBalanceMoneyLabel } from '../../escrow/escrowHeader/AvailableBalanceLabel';
import { HeaderText3TW } from '../../../../tailwindComponents/HeaderTextTW/HeaderTextTW';
import { StyledCardDivTW, StyledCardTextTW } from './feesOverviewCardsStylesTW';

export interface IExpectedCard {
  actual: number;
  available: number;
  totalDeposits: number;
  totalDisbursements: number;
}

export const BalancesCard: React.FC<IExpectedCard> = ({ actual, available, totalDeposits, totalDisbursements }) => {
  return (
    <CardTW className={'grow basis-1/2'} contentClassName={'p-0'}>
      <HeaderText3TW className={'p-4 pb-0'}>Balances</HeaderText3TW>
      <div className={'flex flex-row'}>
        <StyledCardDivTW className={'basis-1/4'}>
          <ActualBalanceMoneyLabel />
          <StyledCardTextTW data-test-id={'actual'}>
            {actual !== 0 ? <Currency value={actual} /> : '--'}
          </StyledCardTextTW>
        </StyledCardDivTW>
        <StyledCardDivTW className={'basis-1/4'}>
          <AvailableBalanceMoneyLabel />
          <StyledCardTextTW data-test-id={'available'}>
            {available !== 0 ? <Currency value={available} /> : '--'}
          </StyledCardTextTW>
        </StyledCardDivTW>
        <StyledCardDivTW className={'basis-1/4'}>
          <Header5Text>Total Deposits</Header5Text>
          <StyledCardTextTW data-test-id={'total-deposits'}>
            {totalDeposits !== 0 ? <Currency value={totalDeposits} /> : '--'}
          </StyledCardTextTW>
        </StyledCardDivTW>
        <StyledCardDivTW className={'basis-1/4'}>
          <Header5Text>Disbursements</Header5Text>
          <StyledCardTextTW data-test-id={'total-disbursements'}>
            {totalDisbursements !== 0 ? <Currency value={totalDisbursements} /> : '--'}
          </StyledCardTextTW>
        </StyledCardDivTW>
      </div>
    </CardTW>
  );
};
